import { isMobile } from '@/consts/device';
import { isPortfolioApp } from '@/utils/environment/surface';

/**
 * Whether the streak feature may render on this surface at all.
 *
 * Deliberately not an auth check any more (PIA-291366): a guest sees the same
 * Claim pill and a day-1 sheet as the signup pitch, so auth is a branch inside
 * the feature (`useStreakState().isGuest`) rather than its on/off switch.
 */
const useFreePassEnabled = (): boolean => isPortfolioApp() && isMobile;

export default useFreePassEnabled;
